<template>
    <div>
        <myPage :max_flag="true">
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                </el-button-group>
                <el-button class="mg-top5" type="primary" @click="openSave('add',$t('root'))" size="small">{{$t("add_sub")}}</el-button>
            </div>
            <div class="fillw fillh">
                <div class="tree-box fillh" style="overflow-y: auto">
                    <div v-for="item in listData" :key="item.func_id">
                        <div class="flex-box pd-5">
                            <div><Icon class="left-icon" type="ios-arrow-down" />{{item.func_cname}}({{item.func_id}})</div>
                            <div class="flex-box-bd"></div>
                            <el-button class="round-5 mg-right5" type="primary" size="mini" @click="openSave('add',item.func_cname,item.func_id)">{{$t("add_sub")}}</el-button>
                            <el-button class="round-5" type="warning" size="mini" @click="openSave('upd',item.func_cname,item.func_id)">{{$t("info")}}</el-button>
                        </div>
                        <div class="sub-tree c1" v-for="item2 in item.children" :key="item2.func_id">
                        <span><Icon class="left-icon" type="ios-arrow-down" />{{item2.func_cname}}({{item2.func_id}})
                            <el-button class="round-5" type="primary" size="mini" @click="openSave('add',item.func_cname+'>'+item2.func_cname,item2.func_id)">{{$t("add_sub")}}</el-button>
                            <el-button class="round-5" type="warning" size="mini" @click="openSave('upd',item.func_cname+'>'+item2.func_cname,item2.func_id)">{{$t("info")}}</el-button>
                        </span>
                            <div class="sub-tree c2" v-for="item3 in item2.children" :key="item3.func_id">
                            <span><Icon class="left-icon" type="ios-appstore" />{{item3.func_cname}}({{item3.func_id}})
                                <el-button class="round-5" type="warning" size="mini" @click="openSave('upd',item.func_cname+'>'+item2.func_cname+'>'+item3.func_cname,item3.func_id)">{{$t("info")}}</el-button>
                            </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </myPage>
        <myDrawer v-model="show_subview">
            <router-view></router-view>
        </myDrawer>
    </div>
</template>

<script>
    export default {
        name:'system-func',
        components:{
        },
        data:function(){
            return{
                show_subview:false,
                relist:false,
                search:{
                    search_url:'func/list'
                },
                listTable: {},//表结构
                listData: [],
                totalData: {
                    total: 0,//总行数
                }
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.$base.listPageInit(this,()=>{
                this.list();
            });
        },
        methods:{
            list: function () {
                this.$base.showLoading();
                this.$request.sendPost(this.search.search_url,this.search,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.listData = data.list;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            openSave:function (op, name, id) {
                this.$base.linkTo("/system/func/save",{op: op,id: id,func_pcname: name});
            }
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(true);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>
    .tree-box{
        max-width: 600px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/system/func.vue